import Vue from 'vue'
import VueRouter from 'vue-router'
import PaginaInicio from '@/views/PaginaInicio.vue'
//import SelectorIdioma from '@/components/SelectorIdioma.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: PaginaInicio
  },
  {
    path: '/reservar',
    name: 'Reservar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: SelectorIdioma
    component: () => import (/* webpackChunkName: "about" */ '@/views/PaginaReservar.vue')
  },
  {
    path: '/cancelarReserva',
    name: 'cancelarReserva',
    component: () => import (/* webpackChunkName: "about" */ '@/views/PaginaCancelarReserva.vue')
  }, 
  {
    path: '/obtenerFactura',
    name: 'obtenerFactura',
    component: () => import ('@/views/PaginaObtenerFactura.vue')
  },
  {
    path: '/continuarReserva',
    name: 'continuarReserva',
    component: () => import (/* webpackChunkName: "about" */ '@/views/PaginaContinuarReserva.vue')
  }, 
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import ('@/views/PaginaFAQ.vue')
  },
/*  {
    path: '/avisolegal',
    name: 'Aviso legal',
    component: () => import ('@/views/PaginaAvisoLegal.vue')
  },*/
  { 
    path: '/avisolegal/:tipoPagina', 
    name: 'aviso_legal', 
    component: () => import ('@/views/PaginaCondicionesLegales.vue')
  },
  {
    path: '/politicaprivacidad',
    name: 'Politica privacidad',
    component: () => import ('@/views/PaginaPoliticaPrivacidad.vue')
  },
  {
    path: '/zbe',
    name: 'ZBE',
    component: () => import ('@/views/PaginaZBE.vue')
  },
  {
    path: '/comofunciona',
    name: 'comoFunciona',
    component: () => import ('@/views/PaginaComoFunciona.vue')
  }

]

const router = new VueRouter({
  routes
})

export default router
